import { useState, type FormEvent } from "react";
import { Link, useNavigate } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function Hero() {
  const [keyword, setKeyword] = useState("");
  const navigate = useNavigate();

  const onSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/square?q=${encodeURIComponent(q)}` : "/square");
  };

  return (
    <section className="relative w-full min-h-[560px] md:min-h-[680px] flex items-center overflow-hidden">
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20abstract%20dark%20crimson%20and%20amber%20gradient%20backdrop%20with%20floating%20folded%20paper%20notes%2C%20blurred%20newsroom%20silhouettes%20and%20soft%20volumetric%20light%20rays%2C%20dramatic%20editorial%20poster%20art%2C%20cinematic%20minimal%20composition%2C%20rich%20contrast%20suitable%20for%20white%20text%20overlay&width=1600&height=900&seq=baoliao-hero-main&orientation=landscape"
          alt="511爆料匿名投稿平台首屏视觉"
          title="511爆料 匿名投稿 我要爆料"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/40 to-black/60"></div>
        <div className="absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-background-50 to-transparent"></div>
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-8 pt-28 pb-20 md:pt-32 md:pb-24">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/15 border border-background-50/25 text-background-50 text-xs md:text-sm">
            <span className="w-2 h-2 rounded-full bg-accent-400 pulse-dot"></span>
            匿名投稿入口长期开放 · 平均审核 38 分钟
          </span>

          <h1 className="mt-6 font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-background-50 leading-tight">
            把线索交给 {siteInfo.name}
            <br />
            <span className="text-accent-300">让每一条爆料都有回应</span>
          </h1>

          <p className="mt-5 text-sm md:text-base text-background-100/90 leading-relaxed max-w-2xl">
            511爆料支持 私信投稿、投喂瓜料、我要爆料 等多种投喂方式，线索直达后台人工审核，投稿人身份默认脱敏。
            瓜料被采纳后进入热门发酵环节，我们持续跟进、持续更新状态。
          </p>

          <form
            onSubmit={onSearch}
            className="mt-7 flex flex-col sm:flex-row gap-2.5 max-w-xl"
            role="search"
          >
            <div className="flex-1 flex items-center gap-2 bg-background-50 rounded-md px-4 h-12">
              <span className="w-5 h-5 flex items-center justify-center text-foreground-400">
                <i className="ri-search-line"></i>
              </span>
              <input
                type="search"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索瓜料关键词，例如：综艺内幕"
                className="flex-1 bg-transparent text-sm text-foreground-900 placeholder:text-foreground-400 outline-none"
                aria-label="搜索爆料关键词"
              />
            </div>
            <button
              type="submit"
              className="h-12 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors flex items-center justify-center gap-2"
            >
              <i className="ri-search-line"></i>
              搜索瓜料
            </button>
          </form>

          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to="/submit"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md bg-background-50 text-foreground-950 text-sm font-medium whitespace-nowrap hover:bg-background-100 transition-colors"
            >
              <i className="ri-flashlight-line text-primary-500"></i>
              一键进入爆料
            </Link>
            <Link
              to="/square"
              className="inline-flex items-center gap-2 px-6 py-3 rounded-md border border-background-50/40 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-background-50/15 transition-colors"
            >
              <i className="ri-fire-line"></i>
              浏览爆料广场
            </Link>
          </div>
        </div>

        <dl className="mt-12 md:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 max-w-4xl">
          {siteInfo.stats.map((stat) => (
            <div
              key={stat.label}
              className="px-4 py-3.5 rounded-lg bg-background-50/10 border border-background-50/20 backdrop-blur-sm"
            >
              <dt className="text-xs text-background-200/90">{stat.label}</dt>
              <dd className="mt-1 font-heading text-xl md:text-2xl font-bold text-background-50">
                {stat.value}
              </dd>
            </div>
          ))}
        </dl>
      </div>
    </section>
  );
}